
import newsimg from '../Images/ic_news.png'
import sensorimg from '../Images/ic_sensor_white.png'


function TabBar(props){
  return(     
    <div className="row tabbar mt-md-0 mt-3 mt-sm-3"> 
      <div className=  {`col-6  d-flex flex-wrap justify-content-center align-items-center tabbartab ${props.tabBarSelect === 0 ? "selected" : ""}`} onClick={() => props.setTabBarSelect(0)}>
        <img className={`tabbaricon ${props.tabBarSelect === 0 ? "selectedicon" :""}`} src={newsimg} alt="" ></img>
      </div>
      <div className= {`col-6 d-flex justify-content-center flex-wrap align-items-center tabbartab ${props.tabBarSelect === 1 ? "selected" : ""}`} onClick={() => props.setTabBarSelect(1)}>
        <img className={`tabbaricon ${props.tabBarSelect === 1 ? "selectedicon" : ""}`} src={sensorimg} alt="" ></img>
      </div>
    </div>
  )
}

export default TabBar;